import {AbstractReactComponent, ff, i18n, Icon} from 'mc/lib';
import {FormActions, FormBody} from 'mc/lib/form';
import {requireFields} from 'mc/lib/utils';
import React from 'react';
import {Alert, Button} from 'reactstrap';
import {propTypes, reduxForm, SubmissionError} from 'redux-form';
import {Api} from '../../api';
import {ZadostRozhodnuti} from '../../enums';

const validateRequiredFields = requireFields(['refCislo']);

class ZadostStateCheckForm extends AbstractReactComponent {

    static formName = 'zadostStateCheck';

    static propTypes = {
        ...propTypes,
    };

    static validate = values => {
        return validateRequiredFields(values);
    };

    state = {
        refCislo: null,
        rozhodnuti: null
    };

    onSubmit = (data) => {
        this.setState({refCislo: null, rozhodnuti: null});

        return Api.checkZadost({refCislo: data.refCislo.replace(/-/g, '')}).then((zadostCheck) => {
            if (!zadostCheck.refCislo) {
                throw new SubmissionError({_error: i18n('zadostStateCheck.notFound')});
            } else {
                this.setState({...zadostCheck});
            }
        });
    };

    render() {
        const {error, handleSubmit, pristine, submitting} = this.props;
        const {refCislo, rozhodnuti} = this.state;

        return (
            <form onSubmit={handleSubmit(this.onSubmit)}>
                <FormBody>
                    <h3 className="text-center">{i18n('zadostStateCheck.title')}</h3>
                    {error && <Alert color="danger">{error}</Alert>}
                    {refCislo && (
                        <Alert color="info">
                            {i18n('zadostStateCheck.stateInfo')}<br/>
                            <strong>{refCislo.match(/.{4}/g).join('-')}</strong> je <strong>{ZadostRozhodnuti.getCaption(rozhodnuti).toLowerCase()}</strong>.
                        </Alert>
                    )}
                    <ff.String name="refCislo"
                               label={i18n('zadostStateCheck.refNumber')}
                               labelClass={'text-left'}
                               placeholder="XXXX-9999-9999-9999"
                               required/>
                </FormBody>
                <FormActions>
                    <Button color="primary"
                            block
                            type="submit"
                            disabled={pristine || submitting}>
                        {submitting && <Icon icon="spinner" animation={Icon.animation.spin}/>} {i18n('zadostStateCheck.submit')}
                    </Button>
                </FormActions>
            </form>
        )
    }
}

const formConfig = {
    form: ZadostStateCheckForm.formName,
    validate: ZadostStateCheckForm.validate
};

export default reduxForm(formConfig)(ZadostStateCheckForm);
